<template>
  <main class="main home-page">
    <div class="section hero-section">
      <div class="wrapper">
        <div class="title small">{{ $t("Hello Stranger!") }}</div>
        <div class="title">
          {{
            $t("Welcome to our little corner of the internet, where you can")
          }}
          <span class="purple">{{ $t("chat with friends") }}</span>
          {{ $t("and meet") }}
          <span class="yellow">{{ $t("new people") }}</span>
          {{ $t("and enjoy open conversations -") }}
          <span class="pink">{{ $t("all completely anonymously.") }}</span>
        </div>
        <div @click="letsStart()" class="button colored">
          {{ $t("Let`s start") }}
        </div>
        <transition name="fade">
          <div class="desc red" v-if="error">{{ $t(error) }}</div>
        </transition>
      </div>
    </div>
    <div class="section section-2">
      <img class="img" src="../images/star.webp" />
      <div class="wrapper">
        <div class="title big">
          {{ $t("Safe space is for everyone") }}
        </div>
        <div class="desc">
          {{ $t("safe_space_desc") }}
        </div>
      </div>
    </div>
    <div class="section section-3">
      <div class="wrapper">
        <div class="left">
          <img class="img" src="../images/diamond.webp" />
          <div class="title tinyest">{{ $t("incognito mode") }}</div>
          <div class="icon">
            <img class="img" src="../images/incognito.svg" />
          </div>
        </div>
        <div class="right">
          <div class="title">
            {{ $t("Enter incognito mode with *Company name*") }}
          </div>
          <div class="desc">
            {{ $t("enter_incognito_desc") }}
          </div>
        </div>
      </div>
    </div>
    <div class="section section-4">
      <div class="wrapper">
        <div class="left">
          <div class="title">
            {{ $t("Modern social networks and messengers") }}
          </div>
          <div class="desc">
            {{ $t("modern_social_networks_desc") }}
          </div>
        </div>
        <div class="right">
          <img class="img" src="../images/blackStar.webp" />
          <div class="title tinyest">{{ $t("safe space") }}</div>
          <div class="icon">
            <img class="img" src="../images/shield.svg" />
          </div>
        </div>
      </div>
    </div>
    <div class="section section-5">
      <div class="wrapper">
        <div class="title">
          {{ $t("Now you can") }}
          <span class="yellow">{{ $t("connect with friends") }}</span>
          {{ $t("and") }}
          <span class="red">{{ $t("meet new people") }}</span
          >{{ $t(", share your") }}
          <span class="pink">{{ $t("thoughts") }}</span
          >{{ $t(" or secrets, and enjoy real conversations — ") }}
          <span class="vawe">{{ $t("all completely anonymously.") }}</span>
        </div>
        <div @click="letsStart()" class="button colored">
          {{ $t("Let`s start") }}
        </div>
        <transition name="fade">
          <div class="desc red" v-if="error">{{ $t(error) }}</div>
        </transition>
      </div>
    </div>
    <div class="section section-6">
      <div class="wrapper">
        <div class="left">
          <img class="rock" src="../images/section5/rock.webp" />
          <img class="star1" src="../images/section5/star1.webp" />
          <img class="star2" src="../images/section5/star2.webp" />
          <img class="star3" src="../images/section5/star3.webp" />
          <div class="title big">
            {{ $t("Our space") }}<br />
            {{ $t("Our") }}
            <span class="red">{{ $t("rules") }}</span>
          </div>
        </div>
        <div class="right">
          <div class="item item-pink">
            <div class="title">{{ $t("no names") }}</div>
          </div>
          <div class="list">
            <div class="item item-green">
              <div class="title">{{ $t("no spam") }}</div>
            </div>
            <div class="item item-red">
              <div class="title">{{ $t("no ads") }}</div>
            </div>
            <div class="item item-purple">
              <div class="title">{{ $t("no history") }}</div>
            </div>
            <div class="item item-yellow">
              <div class="title">{{ $t("no danger") }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Home",
  props: [],
  components: {},
  data: function () {
    return {
      error: "",
    };
  },
  mounted() {},
  methods: {
    letsStart() {
      let self = this;
      if (self.authenticated) {
        self.error = "You are already logged in to your account";
        setTimeout(function () {
          self.error = "";
        }, 3000);
      } else {
        this.$router.push("/register");
      }
    },
  },
  computed: {
    ...mapGetters("user", ["authenticated"]),
  },
};
</script>
